module.exports = __webpack_public_path__ + "img/Welfare-bao.6fe0bf36.png";